/**
 * THE TICKET DATE — the day a ticket is filed under on the lists that sort,
 * filter and display tickets by date (api#1329, migration 0604).
 *
 * The API decides it: when the tenant has set
 * `companies.date_tickets_by_finish_day_from` and this ticket's end_date is on
 * or after that cutover, `ticket_date` is the FINISH day; otherwise it is
 * `work_date`. One definition, server-side (fieldiq-api
 * src/lib/ticket-pay-period.ts). This file reads it and never recomputes it —
 * comparing end_date against the cutover here would be a second answer to the
 * same question, and the tenant setting is not on the wire for a list row.
 *
 * Falling back to work_date is for a payload that predates the key (an older
 * cached list) and for a ticket created offline that the server has not seen.
 * It is the same answer the API gives for every tenant with the setting off,
 * so it is not a guess. NOT covered: an offline EDIT merges its body over the
 * cached server row, which keeps the server's last ticket_date until the next
 * sync — the same staleness that row already had for work_date.
 *
 * work_date is still the ARRIVAL day everywhere else, and screens that show
 * arrival and finish keep reading work_date / end_date for those.
 *
 * Absent stays absent: null, never '' — the caller renders it as an em dash.
 */
export function readTicketDate(t: any): string | null {
  if (!t) return null;
  const v = t.ticket_date ?? t.ticketDate ?? t.work_date ?? t.workDate ?? null;
  return v == null || v === '' ? null : String(v);
}
